module.exports = __webpack_public_path__ + "static/wesele promo_2_1-10f655a4eaff8ba7255e242254da70f8.mp4";